var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about",attrs:{"id":"about","name":"about"}},[_c('div',{staticClass:"about-layout"},[_c('el-row',{attrs:{"gutter":10}},[_c('div',[_c('CenterMenu')],1),_c('el-col',{attrs:{"span":20}},[_c('div',{staticClass:"about-content"},[_c('div',{staticClass:"extra"}),_c('MyMarkdown'),_c('div',{staticClass:"extra1"})],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }